export const DEFAULT_SORT_JOB_TEMPLATE = '-lastUpdated';
export const DEFAULT_CURRENT_PAGE = 1;
export const SORT_ARRAY_VALUE = 'sorts[]';
export const LIMIT_ITEM = 10;
export const LIMIT_LIST_EXISTING_TEMPLATE = 12;
